import { createDomain, sample } from 'effector'
import { driverModel } from '~/entities/Driver'
import { AxiosErrorType, DriverCreateSelfEmployedEvent } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain(
  'features.DriverOccupations.ListDriverOccupations.SendSelfEmployedModal',
)

export const submit = domain.createEvent<{
  fn: () => void
}>()

export const submitFx = domain.createEffect<
  {
    fn: () => void
  },
  void,
  AxiosErrorType
>({
  async handler({ fn }) {
    const event = new DriverCreateSelfEmployedEvent()
    await event.create()
    await driverModel.getDriverSilentFx()
    fn()
  },
})

sample({
  clock: submit,
  target: submitFx,
})

sample({
  clock: submitFx.doneData,
  fn() {
    return {
      title: 'Ваши данные по Парковый Самозанятый отправлены на проверку!',
      description: 'это может занять до 5 минут',
      variant: 'success' as const,
    }
  },
  target: notificationModalOpen,
})

sample({
  clock: submitFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
